import React, { useState } from 'react';

const CONSENT_KEY = 'oscop-cookie-consent';

const CookieConsent = () => {
  const initialChoice = typeof window === 'undefined' ? null : window.localStorage.getItem(CONSENT_KEY);
  const [choice, setChoice] = useState(initialChoice);
  const [open, setOpen] = useState(initialChoice === null);
  const decide = (value) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setChoice(value);
    setOpen(false);
    if (value === 'refused' && window.posthog) {
      if (window.posthog.opt_out_capturing) window.posthog.opt_out_capturing();
      if (window.posthog.reset) window.posthog.reset();
    }
    if (value === 'accepted' && choice !== 'accepted') window.location.reload();
  };
  return (
    <>
      {open && (
        <section role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title" className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl dark:border-slate-700 dark:bg-slate-900" data-testid="cookie-consent-banner">
          <h2 id="cookie-consent-title" className="text-lg font-bold text-slate-900 dark:text-white">Vos choix de confidentialité</h2>
          <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">Les traceurs strictement nécessaires fonctionnent sans consentement. La mesure d’audience PostHog n’est activée qu’avec votre accord. Consultez notre <a href="/politique-rgpd" className="font-semibold underline">politique de confidentialité</a>.</p>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            <button type="button" onClick={() => decide('refused')} className="rounded-xl border-2 border-indigo-700 px-5 py-3 font-semibold text-indigo-800 hover:bg-indigo-50 dark:text-indigo-200" data-testid="cookie-refuse">Tout refuser</button>
            <button type="button" onClick={() => decide('accepted')} className="rounded-xl border-2 border-indigo-700 bg-indigo-700 px-5 py-3 font-semibold text-white hover:bg-indigo-800" data-testid="cookie-accept">Tout accepter</button>
          </div>
        </section>
      )}
      <button type="button" onClick={() => setOpen(true)} className="fixed bottom-4 left-4 z-[99] rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 shadow-lg hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200" data-testid="cookie-manage">Gérer les cookies</button>
    </>
  );
};

export default CookieConsent;
